const base = {
    // Header
    classroom_list: "Classroom List",
    logout: "Logout",
    // Footer
    copyright: "Copyright",
    all_rights_reserved: "All rights reserved",
    privacy_policy: "Privacy Policy",
    // Sidebar
    main_menu: "Main Menu",
    account_settings: "Account Settings",
    settings: "Settings",
    Courses: "Courses",
    dashboard: "Dashboard",

    //Student detail
    student_details: "Student Details",
    back_to_list: "Back to List",
    contact_details: "Contact Details",
    email: "Email",
    phone: "Phone",

    //Portfolios
    portfolios: "Portfolios",
    portfolio_details: "Portfolio Details",
    add_portfolio: "Add Portfolio",
    edit_portfolio: "Edit Portfolio",
    update_portfolio: "Update Portfolio",
    delete_confirm_title: "Delete Portfolio",
    delete_confirm_detail: "Are you sure you want to delete the portfolio from :date_field?",
    cancel: "Cancel",
    confirm_delete: "Yes, delete",
    deleting: "Deleting...",
    view_details: "View Details",
    successfully_created_portfolio: "Portfolio has been created succesfully.",
    successfully_updated_portfolio: "Portfolio has been updated succesfully.",
    successfully_deleted_portfolio: "Portfolio deleted successfully!",
    failed_fetch_portfolios: "Failed to refresh portfolios.",
    failed_delete_portfolio: "Failed to delete the portfolio.",
    required_field: ":input_field is required.",
    attendance: "Attendance",
    participation: "Participation",
    homework: "Homework",
    documents: "Documents",
    concentration: "Concentration",
    homework_description: "Homework Description",
    enter_homework_details: "Enter details about the homework...",
    student_note: "Note to Student",
    parent_note: "Note to Parent",
    manager_note: "Note to Institution Manager",
    enter_note: "Enter note...",
    saving: "Saving...",
    no_content: "No content provided.",
    close: "Close"


}
export default base
